import React from 'react';
import styled from 'styled-components';

// --- Main Container ---
const AboutUsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 20px;
  font-family: Arial, sans-serif;
  max-width: 1400px;
  margin: 0 auto;
  gap: 40px;

  @media (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 60px 40px;
    gap: 60px;
  }
`;

// --- Left Content Area ---
const TextContentWrapper = styled.div`
  width: 100%;

  @media (min-width: 992px) {
    width: 55%;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.5em;
  color: brown;
  margin-bottom: 10px;
  font-weight: bold;
  font-family: times-new-roman;
`;

const SectionSubtitle = styled.h3`
  font-size: 1.2em;
  color: #555;
  margin-bottom: 25px;
  font-weight: 500;
`;

const Paragraph = styled.p`
  font-size: 1em;
  line-height: 1.6;
  color: #555;
  margin-bottom: 30px;
`;

// --- Right Side Services List ---
const ServicesWrapper = styled.div`
  width: 100%;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px;
  padding: 30px 25px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  

  @media (min-width: 992px) {
    width: 40%;
  }
`;

const ServicesTitle = styled.h3`
  font-size: 1.8em;
  color: #007bff;
  margin-bottom: 25px;
  font-weight: bold;
  position: relative;
  padding-bottom: 12px;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 3px;
    background-color: #007bff;
    border-radius: 2px;
  }
`;

const ServicesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ServiceItem = styled.li`
  display: flex;
  align-items: center;
  padding: 12px 0;
  font-size: 1.1em;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 500;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:before {
    content: "▷";
    color: #007bff;
    font-size: 1.3em;
    margin-right: 12px;
    font-weight: bold;
  }
`;

const AboutUsComponent = () => {
  const services = [
    'OPD Consultation',
    'Day Care',
    'ECG',
    'TMT',
    'LFT (Lung Function Test)',
    'Nebulization',
    'Fibro Scan',
    'Lab Investigation'
  ];

  return (
    <AboutUsContainer>
      <TextContentWrapper>
        <SectionTitle>WELCOME TO ISHA HEALTH CARE</SectionTitle>
        <SectionSubtitle>Caring for Life, Every Step of the Way</SectionSubtitle>
        <Paragraph>
          Diabetes is one of the leading disorders to plague our generation today. Yes, it's a disorder, not a disease, and the good news is that it can be well managed with proper self-care and treatment. However, this disorder can lead to a number of serious complications, whether of the heart, nerves or eyes, and if diagnosed late or left untreated, the damage can be irrevocable. <b>It's important to partner with the right diabetes clinic</b>, who devises the right plan to guide you and keep you healthy with the condition.
        </Paragraph>

        <Paragraph>
          Our diabetes care center stay with you, every step of the way in controlling and managing your diabetes. We strictly follow the 'total involvement' approach, with our focus being on treating the person, not just the disorder. Think of us as an extended part of your family, caring for you sensitively, like a family or friend, and taking you to the finish line of being diabetes free.
        </Paragraph>

        <Paragraph>
          With a "no compromises, total quality" Dr Raj Kamal along with Isha Health Care help deliver clinical excellence and patient delight seamlessly, whether in our care centers, over the phone also. With a clear vision that is centred on offering the . service and support, Dr Raj Kamal along with Isha Health Care is dedicated towards offering you the right advice and care.
        </Paragraph>
      </TextContentWrapper>

      <ServicesWrapper>
        <ServicesTitle>Key Services</ServicesTitle>
        <ServicesList>
          {services.map((service, index) => (
            <ServiceItem key={index}>{service}</ServiceItem>
          ))}
        </ServicesList>
      </ServicesWrapper>
    </AboutUsContainer>
  );
};

export default AboutUsComponent;